import { partStockQuery } from "@common/api/part-stock"
import { useArchivePartMutation } from "@common/api/parts"
import { ConfirmDialog } from "@common/components/shared/confirm-dialog"
import { handleError } from "@common/utils"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"

export const Route = createFileRoute("/_layout/inventory/$partId/archive")({
  component: ArchivePartDialog,
})

function ArchivePartDialog(): React.ReactElement {
  const { partId } = Route.useParams()
  const { data: stock } = useSuspenseQuery(partStockQuery({ part_id: partId }))
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const archiveMutation = useArchivePartMutation()
  const number = stock.part?.number ?? "this part"

  const close = () =>
    navigate({
      to: "/inventory/$partId",
      params: { partId },
      search: true,
    })

  const confirm = () =>
    archiveMutation.mutate(
      { part_id: partId },
      {
        onSuccess: () => {
          showToast("Archived", `${number} archived.`, "success")
          navigate({ to: "/inventory", search: true })
        },
        onError: (error) => handleError(error, showToast),
      },
    )

  return (
    <ConfirmDialog
      title={`Archive ${number}?`}
      description="Archived parts keep their history and appear in the Archived tab."
      action="Archive"
      tone="default"
      pendingAction="Archiving…"
      pending={archiveMutation.isPending}
      onConfirm={confirm}
      onCancel={close}
    />
  )
}
